import bsm from '@/assets/bsm.png';
import icAi from '@/assets/icAi.svg';
import icBack from '@/assets/icBack.svg';
import icM from '@/assets/icM.svg';
import icSend from '@/assets/icSend.svg';
import icSendDisabled from '@/assets/icSendDisabled.svg';
import icBG from '@/assets/icBg.png';
import icArrowLeft from '@/assets/icArrowLeft.svg';
import icDrop from '@/assets/icDrop.svg';
import bgChat from '@/assets/bgChat.png';
// import earth from '@/assets/earth.png';
import earth1 from '@/assets/earth.jpg';
import bg1 from '@/assets/bg1.png';
import icMail from '@/assets/icMail.svg';
import icNews from '@/assets/icNews.svg';
import icBackGreen from '@/assets/icBackGreen.svg';
import icBsm from '@/assets/icBsm.png';
import icMailFilled from '@/assets/icMailF.svg';
import icWeb from '@/assets/icWeb.svg';
import icHD from '@/assets/icHD.png';
import icLoa from '@/assets/icLoa.svg';
import icLogo1 from '@/assets/icLogo1.png';
import icText from '@/assets/icText.png';
import bgMobile from '@/assets/bgMobile.png';

export const ASSETS = {
  bsm,
  icAi,
  icBack,
  icM,
  icSend,
  icSendDisabled,
  icBG,
  icArrowLeft,
  icDrop,
  bgChat,
  // earth,
  bg1,
  earth1,
  icMail,
  icNews,
  icBackGreen,
  icBsm,
  icMailFilled,
  icWeb,
  icHD,
  icLoa,
  icLogo1,
  icText,
  bgMobile,
};
